import { Button, useTheme } from '@mui/material'
import React from 'react'

const PrimaryButton = (
  {
    onClick,
    buttonText,
    variant,
    ...props
  }
) => {
  const theme = useTheme()

  const styleAccordingToVariant = {
    outlined: {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main
    },
    content: {
      borderColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark
      }
    }
  }

  return (
    <Button
      type='button'
      onClick={onClick}
      fullWidth
      variant={variant}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '14px',
        fontWeight: 700,
        lineHeight: '14px',
        py: 2,
        borderWidth: 1,
        ...styleAccordingToVariant.variant
      }}
      {
                        ...props
                      }
    >
      {buttonText}
    </Button>
  )
}

export default PrimaryButton
